import withAuth from "./WithAuth";

export default withAuth;
